import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { useDispatch } from 'react-redux'
import { showErrorToast } from '../../state/toasts'
export const DeleteListOption = ({ item, onDelete }) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.ListService(item.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete()
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', 'Could not delete list option'))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to delete item?"
        confirmText="Confirm Delete List Option"
        confirmBSStyle="danger"
        title="Deleting List Option"
      >
        <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1">
          {components.ICONS.DELETE} Delete
        </ReactBootstrap.Dropdown.Item>
      </components.Confirm>
    </>
  )
}
